module.exports = __webpack_public_path__ + "img/logo.91938d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tpl/logo.png
// module id = 4l8l
// module chunks = 57